import { render, staticRenderFns } from "./inputCardTag.vue?vue&type=template&id=fd807a7e"
import script from "./inputCardTag.vue?vue&type=script&lang=js"
export * from "./inputCardTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports